var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',[_vm._v("Click me to do nothing")]),_c('button',{on:{"click":function($event){return _vm.$emit('done')}}},[_vm._v("Finish game")])])}
var staticRenderFns = []

export { render, staticRenderFns }